import { CampaignSegmentationsModel, ICampaignSegmentationCreateForm, SegmentationModel } from '../models/campaign-segmentation.model';
import { randomNumber } from '@monorepo/tools/src/lib/utils/number';
import { IRequestOptions } from '@monorepo/tools/src/lib/interfaces/url';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { WebappsCidApi } from './webapps-cid.api';

export const CampaignSegmentationsApi = {
	create: async (
		campaignSegmentation: ICampaignSegmentationCreateForm,
		options?: IRequestOptions
	): Promise<CampaignSegmentationsModel> => {
		const selectedCid = campaignSegmentation?.getCid();
		if (!selectedCid) {
			return new Promise(res => res(new CampaignSegmentationsModel()));
		}

		return WebappsCidApi.createSegments(
			selectedCid,
			{
				cid_segments:
					campaignSegmentation?.getSegmentations()?.map(seg => ({
						auction_package_id: seg.auction_package_id!,
						auction_package_name: seg.auction_package_name || '',
						target_cid: seg.target_cid!,
					})) || [],
			},
			options
		).then(() => new CampaignSegmentationsModel());
	},

	edit: (): Promise<CampaignSegmentationsModel> => {
		throw new Error('Not implemented');
	},

	list: async (): Promise<CampaignSegmentationsModel[]> => {
		throw new Error('Not implemented');
	},

	get: async (cid: id): Promise<{ cid_segments: SegmentationModel[] }> => {
		return WebappsCidApi.getSegments(cid).then(res => ({
			cid_segments: (res.cid_segments || []).map(
				segment =>
					new SegmentationModel({
						...segment,
						id: segment.id || parseInt(randomNumber(111, 444, 0)),
					})
			),
		}));
	},

	delete: async () => {
		throw new Error('Not implemented');
	},
};
